// extracted by mini-css-extract-plugin
export default {"page_layout":"CompleteOrder_page_layout__AkvjK","confirmation_screen_buttons":"CompleteOrder_confirmation_screen_buttons__Csact"};